module.exports = __webpack_public_path__ + "img/img15.58c2173a.png";